

import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Container, Row, Col, Table } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
// import axios from '../Axiosinstance';

import { removeBracketedText } from '../Axiosinstance';
import Contract from '../pdf/contract.pdf';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { saveAs } from 'file-saver';
import Contractnew from '../pdf/contract-aug.pdf';



const App = forwardRef(({ dataProp }, ref) => {


  const handlePdfEdit = async () => {
    const enrolleddate = dataProp?.enrolledDate || '';

    const enrolledDateObj = new Date(enrolleddate);
    const cutoffDate = new Date('2026-08-01');

    const selectedContract =
      enrolledDateObj < cutoffDate
        ? Contract
        : Contractnew;

    const pdfBytes = await fetch(selectedContract).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    const secondPage = pages[1];
    const sevenPage = pages[6];
    const twelvePage = pages[11];
    const eighthPage = pages[7];
    const ninethPage = pages[8];
    const tenthPage = pages[9];




    const helveticaBoldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const defaultFont = await pdfDoc.embedFont(StandardFonts.Helvetica);


    const studentName = (dataProp?.student?.fullname || '').toUpperCase();
    const nric = dataProp.student?.nric || '';
    const course = (dataProp?.batch?.course || '').toUpperCase().replace(/\s*\(1\)$/, '');
    const coursetype = (dataProp?.batch?.courseType || '').toUpperCase();
    const commencementDate = formatDate(dataProp.scheduleDate[0]?.startDate);
    const completionDate = calculateCompletionDateonlyfordate(dataProp.scheduleDate[0]?.startDate, dataProp.type);
    const courseDuration = dataProp.type === 'diploma' ? '12 ' : dataProp.type === 'advance_diploma' ? '6 ' : '';
    const confermentDate = formatDate(formattedNextMonthDate);
    const approver = (dataProp?.approver).toUpperCase() || '';
    const lastDate = dataProp.late ? commencementDate : formatDate(dataProp?.paidDate);
    const regFees = Number(dataProp?.batch?.registrationFee ?? 0).toFixed(2);


    const courseFees = `${dataProp?.batch?.courseFee || 0}`;
    const courseFeesTotal = `$${dataProp?.batch?.courseFee || 0}`;


    const taxDeductedCourseFees = `$${dataProp?.batch?.courseFee - 150 || 0}`; // Subtracting $150 for tax deduction
    const materialfees = "$150";




    const getTextWidth = (text, font, fontSize) => {
      const width = font.widthOfTextAtSize(text, fontSize);
      return width;
    };


    function replaceTabs(text) {
      if (typeof text !== 'string') {
        return ''; // Return an empty string if the input is not a valid string
      }
      return text.replace(/\t/g, '    '); // Replace each tab with four spaces
    }

    // Function to draw wrapped text with dynamically adjusted X-axis position
    const drawWrappedText = async (page, text, x, y, font, fontSize, maxWidth) => {
      text = replaceTabs(text);
      const lines = [];
      let currentLine = '';
      const words = text.split(' ');

      for (let i = 0; i < words.length; i++) {
        const word = words[i];
        const width = getTextWidth(currentLine + ' ' + word, font, fontSize);

        if (width < maxWidth) {
          currentLine += (currentLine === '' ? '' : ' ') + word;
        } else {
          lines.push(currentLine.trim());
          currentLine = word;
        }
      }

      if (currentLine !== '') {
        lines.push(currentLine.trim());
      }

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        const lineWidth = getTextWidth(line, font, fontSize);

        await page.drawText(line, {
          x: i === 0 ? x : x,  // Keep the initial X position for all lines
          y: y - i * 12,       // Adjust the line height as needed
          size: fontSize,
          font,
          color: rgb(0, 0, 0),
        });
      }
    };


    const fontSize = 11;
    const maxWidth = 135;
    const lineHeight1 = fontSize + 4;


    // Text wrap function
    function wrapText(text, font, fontSize, maxWidth) {
      const words = text.split(' ');
      const lines = [];
      let currentLine = '';

      for (const word of words) {
        const testLine = currentLine ? `${currentLine} ${word}` : word;
        const testWidth = font.widthOfTextAtSize(testLine, fontSize);

        if (testWidth <= maxWidth) {
          currentLine = testLine;
        } else {
          if (currentLine) lines.push(currentLine);
          currentLine = word;
        }
      }

      if (currentLine) lines.push(currentLine);
      return lines;
    }

    const wrappedLines = wrapText(studentName, helveticaBoldFont, fontSize, maxWidth);

    // Fixed bottom anchor for 1 line
    const boxX = 395;
    const boxY = 540;

    // Compute total height of the block
    const totalTextHeight = wrappedLines.length * lineHeight1;

    // For single line, use fixed Y
    // For multi-line, move startY upwards so the last line lands at boxY
    const startY = wrappedLines.length === 1
      ? boxY
      : boxY + (wrappedLines.length - 1) * lineHeight1;

    wrappedLines.forEach((line, index) => {
      const textWidth = helveticaBoldFont.widthOfTextAtSize(line, fontSize);
      const x = boxX + (maxWidth - textWidth) / 2;
      const y = startY - index * lineHeight1;

      secondPage.drawText(line, {
        x,
        y,
        size: fontSize,
        font: helveticaBoldFont,
        color: rgb(0, 0, 0),
      });
    });




    const drawStudentName2 = (page, name) => {
      const maxWidth = page.getWidth();
      let fontSize = 20;

      // Reduce font size until text fits
      while (helveticaBoldFont.widthOfTextAtSize(name, fontSize) > maxWidth) {
        fontSize -= 1;
        if (fontSize <= 15) break; // safety limit
      }

      const textWidth = helveticaBoldFont.widthOfTextAtSize(name, fontSize);
      const centerX = (page.getWidth() - textWidth) / 2;

      page.drawText(name, {
        x: centerX,
        y: 304,
        size: fontSize,
        font: helveticaBoldFont,
        color: rgb(0, 0, 0),
      });
    };

    drawStudentName2(firstPage, studentName);



    const drawnric = (page, name) => {
      const fontSize = 20;
      const textWidth = helveticaBoldFont.widthOfTextAtSize(name, fontSize);
      const centerX = (page.getWidth() - textWidth) / 2;
      page.drawText(name, { x: centerX, y: 270, size: fontSize, font: helveticaBoldFont, color: rgb(0, 0, 0) });
    };

    drawnric(firstPage, nric);


    const drawNric2 = (secondPage, nric) => {
      const maxLength = 10; // Set the maximum length of the name
      const defaultX = 441; // Default x position
      const adjustedX = 411; // Adjusted x position for long names
      const xPosition = nric.length > maxLength ? adjustedX : defaultX;
      secondPage.drawText(nric, { x: xPosition, y: 496, size: 10, color: rgb(0, 0, 0) });
    };


    drawNric2(secondPage, nric);

    // firstPage.drawText(studentName, { x: centerX, y: 302, size: 20, font: helveticaBoldFont, color: rgb(0, 0, 0) });
    // firstPage.drawText(nric, { x: 257, y: 276, size: 20, font: helveticaBoldFont, color: rgb(0, 0, 0) });
    // secondPage.drawText(studentName, { x: 392, y: 542, size: 11, color: rgb(0, 0, 0) });
    // secondPage.drawText(nric, { x: 441, y: 496, size: 11, color: rgb(0, 0, 0) });
    // sevenPage, course, 243, 701, defaultFont, 10, 160);
    drawWrappedText(sevenPage, removeBracketedText(course), 243, 705, defaultFont, 10, 282);
    drawWrappedText(sevenPage, removeBracketedText(course), 243, 435, defaultFont, 10, 282);
    // sevenPage.drawText(course, { x: 243, y: 431, size: 10, color: rgb(0, 0, 0) });
    sevenPage.drawText(coursetype, { x: 243, y: 625, size: 10, color: rgb(0, 0, 0) });
    sevenPage.drawText(commencementDate, { x: 243, y: 578, size: 11, color: rgb(0, 0, 0) });
    sevenPage.drawText(completionDate, { x: 243, y: 541, size: 11, color: rgb(0, 0, 0) });
    sevenPage.drawText(courseDuration, { x: 243, y: 659, size: 10, color: rgb(0, 0, 0) });
    eighthPage.drawText(confermentDate, { x: 241, y: 203, size: 12, color: rgb(0, 0, 0) });
    twelvePage.drawText(studentName, { x: 208, y: 456, size: 11, color: rgb(0, 0, 0) });
    twelvePage.drawText(lastDate, { x: 101, y: 573, size: 11, color: rgb(0, 0, 0) });
    twelvePage.drawText(lastDate, { x: 101, y: 441, size: 11, color: rgb(0, 0, 0) });
    ninethPage.drawText(taxDeductedCourseFees.toString(), { x: 436, y: 642, size: 12, color: rgb(0, 0, 0) });
    ninethPage.drawText(courseFees.toString(), { x: 436, y: 491, size: 11, color: rgb(0, 0, 0) });
    ninethPage.drawText(materialfees.toString(), { x: 436, y: 548, size: 12, color: rgb(0, 0, 0) });
    ninethPage.drawText(courseFeesTotal, { x: 321, y: 150, size: 12, color: rgb(0, 0, 0) });
    tenthPage.drawText(`$${regFees}`, { x: 445, y: 554, size: 12, color: rgb(0, 0, 0) });




    twelvePage.drawText(approver, { x: 108, y: 588, size: 10, font: helveticaBoldFont, color: rgb(0, 0, 0) });




    //seventh page course schadule date
    let yPosition = 245; // Start position for the first schedule entry
    const lineHeight = 25;// Space between each schedule entry
    const moduleDetailsMap = {};
    dataProp.batch.moduleDetails.forEach((module) => {
      moduleDetailsMap[module.id] = module.moduleName;
    });



    scheduleData.forEach((schedule, index) => {
      const startDate = formatDate(schedule.startDate);
      const endDate = formatDate(schedule.endDate);
      const moduleName = moduleDetailsMap[schedule.startModulus];


      const scheduleText = `${startDate} To ${endDate} -`;


      sevenPage.drawText(scheduleText, { x: 243, y: yPosition, size: 10, color: rgb(0, 0, 0) });
      drawWrappedText(sevenPage, moduleName, 370, yPosition, defaultFont, 10, 160);
      yPosition -= lineHeight; // Move down for the next entry
    });




    //for installment table
    let yPositionpayent = 356; // Start position for the first schedule entry
    const lineHeightpaymet = 15;


    const height = 15;
    let yindex = 362;
    const monthsDifference = dataProp.type === 'diploma' ? 12 : dataProp.type === 'advance_diploma' ? 6 : 0;


    if (monthsDifference > 0) {
      const courseFees = dataProp?.batch?.courseFee || 0;
      const installmentAmount = Math.round(courseFees / monthsDifference);


      for (let i = 1; i <= monthsDifference; i++) {
        const dueDate = new Date(dataProp.scheduleDate[0].startDate); // Start with the first course date
        dueDate.setMonth(dueDate.getMonth() + i - 1); // Move i-1 months from the start
        dueDate.setDate(15); // Set the due date to the 15th of the month


        let xPosition = (i <= 9) ? 88.5 : 95.5;


        const formattedDueDate = formatDate(dueDate);


        const ordinalSuffix = getOrdinalSuffix(i); // Function to get the ordinal suffix (st, nd, rd, th)
        const installmentText = `${i} ${' '} instalment`;
        const installmentAmounttext = ` $${Math.round(installmentAmount)}`;
        const installmentDate = `${formattedDueDate}`;
        ninethPage.drawText(installmentText, { x: 82, y: yPositionpayent, size: 12, color: rgb(0, 0, 0) });
        ninethPage.drawText(ordinalSuffix, { x: xPosition, y: yindex, size: 6, color: rgb(0, 0, 0) });


        ninethPage.drawText(installmentAmounttext, { x: 317, y: yPositionpayent, size: 12, color: rgb(0, 0, 0) });
        ninethPage.drawText(installmentDate, { x: 435, y: yPositionpayent, size: 12, color: rgb(0, 0, 0) });


        yindex -= height;
        yPositionpayent -= lineHeightpaymet; // Move down for the next entry
      }
    }




    // Starting position for holidays
    let yPositiondholiday = 748;
    holidays.forEach((holiday) => {


      const holidaydate = formatDate(holiday.date);


      const holidayText = `${holidaydate} - ${holiday.name}`;
      eighthPage.drawText(holidayText, { x: 243, y: yPositiondholiday, size: 10, color: rgb(0, 0, 0) });
      yPositiondholiday -= 14.5;  // Adjust vertical position for next holiday
    });





    //eighth page examination
    let yPositionExam = 567; // Start position for the first schedule entry
    const lineHeightExam = 25;


    scheduleData.forEach((schedule, index) => {
      const endDate = formatDate(schedule.endDate);
      const moduleName = moduleDetailsMap[schedule.startModulus];
      const scheduleText = ` ${endDate} -`;
      eighthPage.drawText(scheduleText, { x: 241, y: yPositionExam, size: 10, color: rgb(0, 0, 0) });
      drawWrappedText(eighthPage, moduleName, 305, yPositionExam, defaultFont, 10, 170);
      yPositionExam -= lineHeightExam;// Move down for the next entry
    });




    //eighth page result  examination
    let yPositionResult = 385; // Start position for the first schedule entry
    const lineHeightResult = 25;


    scheduleData.forEach((schedule, index) => {
      // const startDate = formatEndDate(schedule.startDate);
      const endDate = formatEndDate(schedule.endDate);
      const moduleName = moduleDetailsMap[schedule.startModulus];
      const scheduleText = ` ${endDate} - `;
      eighthPage.drawText(scheduleText, { x: 241, y: yPositionResult, size: 10, color: rgb(0, 0, 0) });
      drawWrappedText(eighthPage, moduleName, 305, yPositionResult, defaultFont, 10, 170);
      yPositionExam -= lineHeightExam;// Move down for the next entry
      yPositionResult -= lineHeightResult; // Move down for the next entry
    });


    // const pdfBytesEdited = await pdfDoc.save();
    // const blob = new Blob([pdfBytesEdited], { type: 'application/pdf' });
    // saveAs(blob, `${studentName}-CONTRACT-LETTER.pdf`);

    const pdfBytesModified = await pdfDoc.save();
    const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, '_blank');
  }


  useImperativeHandle(ref, () => ({
    handlePdfEdit,
  }));

  function calculateCompletionDateonlyfordate(commencementDate, type) {
    const commencement = new Date(commencementDate);
    let completion;

    if (type === 'diploma') {
      // Add 1 year (minus 1 day) to commencement date
      completion = new Date(commencement);
      completion.setFullYear(commencement.getFullYear() + 1);
      completion.setDate(completion.getDate() - 1);
    } else if (type === 'advance_diploma') {
      // Add 6 months (minus 1 day) to commencement date
      completion = new Date(commencement);
      completion.setMonth(commencement.getMonth() + 6);
      completion.setDate(completion.getDate() - 1);
    } else {
      // Handle other types if necessary
      completion = commencement; // Default to the commencement date
    }

    const day = String(completion.getDate()).padStart(2, '0');
    const month = String(completion.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = completion.getFullYear();

    return `${day}/${month}/${year}`;
  }

  function calculateCompletionDate(dateforcomplete, type) {
    const commencement = new Date(dateforcomplete);
    let completion;

    if (type === 'diploma') {
      // Add 1 year (minus 1 day) to commencement date
      completion = new Date(commencement);
      completion.setFullYear(commencement.getFullYear() + 1);
      completion.setDate(completion.getDate() - 1);
    } else if (type === 'advance_diploma') {
      // Add 6 months (minus 1 day) to commencement date
      completion = new Date(commencement);
      completion.setMonth(commencement.getMonth() + 6);
      completion.setDate(completion.getDate() - 1);
    } else {
      // Handle other types if necessary
      completion = commencement; // Default to the commencement date
    }

    return completion.toISOString().split('T')[0]; // Format as YYYY-MM-DD
  }




  const [formValues, setFormValues] = useState({
    nric: dataProp?.student.nric || '',
    studentName: dataProp?.student.fullname || '',
    course: (dataProp?.batch?.course || '').toUpperCase().replace(/\s*\(1\)$/, ''),
    commencementDate: dataProp.scheduleDate[0]?.startDate,
    completionDate: calculateCompletionDate(dataProp.scheduleDate[0]?.startDate, dataProp.type),
    coursetype: dataProp?.batch?.courseType || '',
    CourseFees: dataProp?.courseFee || '',
    typeCourse: dataProp?.student.type || '',
    approver: dataProp?.approver || '',
  });


  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(true);


  // useEffect(() => {
  //   const fetchHolidays = async () => {
  //     try {
  //       const startYear = new Date(formValues.commencementDate).getFullYear();
  //       const endYear = new Date(formValues.completionDate).getFullYear();

  //       const [startYearHolidays, endYearHolidays] = await Promise.all([
  //         fetch(`https://date.nager.at/api/v3/PublicHolidays/${startYear}/sg`).then(response => response.json()),
  //         fetch(`https://date.nager.at/api/v3/PublicHolidays/${endYear}/sg`).then(response => response.json()),
  //       ]);


  //       // Filter holidays between commencementDate and completionDate
  //       const filteredHolidays = startYearHolidays
  //         .concat(endYearHolidays)
  //         .filter(holiday => {
  //           const holidayDate = new Date(holiday.date);
  //           return holidayDate >= new Date(formValues.commencementDate) && holidayDate <= new Date(formValues.completionDate);
  //         });


  //       setHolidays(filteredHolidays);
  //       setLoading(false);
  //       console.log("holidaystart", startYearHolidays)
  //       console.log("holidayend", endYearHolidays)
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     }
  //   };


  //   fetchHolidays();
  // }, [formValues]);


  useEffect(() => {
    let isMounted = true; // Prevent state update on unmounted component

    const fetchHolidays = async () => {
      try {
        setLoading(true);

        if (!formValues.commencementDate || !formValues.completionDate) return;

        const startDate = new Date(formValues.commencementDate);
        const endDate = new Date(formValues.completionDate);

        const startYear = startDate.getFullYear();
        const endYear = endDate.getFullYear();

        const yearsToFetch = [...new Set([startYear, endYear])];

        const responses = await Promise.all(
          yearsToFetch.map(year =>
            fetch(`https://date.nager.at/api/v3/PublicHolidays/${year}/sg`)
              .then(res => (res.ok ? res.json() : []))
              .catch(() => [])
          )
        );

        const allHolidays = responses.flat();

        const safeHolidays = allHolidays
          .filter(h => h?.date && h?.name)
          .filter(h => {
            const d = new Date(h.date);
            return d >= startDate && d <= endDate;
          });

        // 🔥 Remove duplicates safely
        const uniqueHolidays = Array.from(
          new Map(
            safeHolidays.map(h => [`${h.date}-${h.name}`, h])
          ).values()
        );

        // 🔥 Sort by date ASC
        uniqueHolidays.sort(
          (a, b) => new Date(a.date) - new Date(b.date)
        );

        if (isMounted) {
          setHolidays(uniqueHolidays);
          setLoading(false);
        }

      } catch (err) {
        console.error("Holiday fetch failed:", err);
        if (isMounted) setLoading(false);
      }
    };

    fetchHolidays();

    return () => {
      isMounted = false;
    };
  }, [formValues.commencementDate, formValues.completionDate]);


  console.log("dataProdp:lal", dataProp)
  const [data, setData] = useState(dataProp);
  const [scheduleData, setScheduleData] = useState(dataProp.scheduleDate);





  if (loading) {
    return <p>Loading...</p>;
  }


  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return date.toLocaleDateString('en-GB', options);
  };

  const formatEndDate = (endDateStr) => {
    const endDate = new Date(endDateStr);
    const nextMonthDate = new Date(endDate);

    // Set date to 5th and add one month
    nextMonthDate.setDate(5);
    nextMonthDate.setMonth(endDate.getMonth() + 1);

    // Check if the new month has fewer days than the original date
    if (nextMonthDate.getMonth() !== (endDate.getMonth() + 1) % 12) {
      nextMonthDate.setDate(0); // Move to the last day of the previous month
      nextMonthDate.setDate(5); // Then set to the 5th day of that month
    }

    return formatDate(nextMonthDate);
  };


  const firstDate = new Date(data.scheduleDate[0].startDate);
  const lastDate = new Date(data.scheduleDate[data.scheduleDate.length - 1].endDate);
  const monthsDifference = (lastDate.getFullYear() - firstDate.getFullYear()) * 12 + lastDate.getMonth() - firstDate.getMonth() + 1;






  const courseCompletionDate = new Date(firstDate);
  courseCompletionDate.setFullYear(courseCompletionDate.getFullYear() + 1);
  courseCompletionDate.setDate(courseCompletionDate.getDate() - 1);




  // Generate installment table
  const installmentRows = [];
  for (let i = 1; i <= monthsDifference; i++) {
    const dueDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + i - 1, 15);
    const formattedDueDate = `${dueDate.getDate()}/${dueDate.getMonth() + 1}/${dueDate.getFullYear()}`;
    installmentRows.push(
      <tr key={i}>


      </tr>
    );
  }

  const lastModuleEndDate = new Date(data.scheduleDate[data.scheduleDate.length - 1].endDate);
  console.log(lastModuleEndDate, "lastModuleEndDate");

  const nextMonthDate = new Date(lastModuleEndDate);

  // Set date to 5th and add one month
  nextMonthDate.setDate(5);
  nextMonthDate.setMonth(lastModuleEndDate.getMonth() + 1);

  // Check if the new month has fewer days than the original date
  if (nextMonthDate.getMonth() !== (lastModuleEndDate.getMonth() + 1) % 12) {
    nextMonthDate.setDate(0); // Move to the last day of the previous month
    nextMonthDate.setDate(5); // Then set to the 5th day of that month
  }

  console.log(nextMonthDate, "nextMonthDate");

  // Add 15 days
  nextMonthDate.setDate(nextMonthDate.getDate() + 15);

  const formattedNextMonthDate = nextMonthDate.toLocaleDateString('en-US');
  console.log(formattedNextMonthDate, "formattedNextMonthDate");





  const getOrdinalSuffix = (number) => {
    if (number === 1 || number === 21 || number === 31) {
      return 'st';
    } else if (number === 2 || number === 22) {
      return 'nd';
    } else if (number === 3 || number === 23) {
      return 'rd';
    } else {
      return 'th';
    }
  };
  return null;
})


export default App;





